// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Od-24","active":"styles_active__VD0lP","content":"styles_content__bOMEm"};